function l_getFocusableElements(container){return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe")).filter((element)=>!element.closest('[aria-hidden="true"]'))}
function l_disableFocusableElements(container){const focusableElements=l_getFocusableElements(container)
focusableElements.forEach((element)=>{element.setAttribute('tabindex','-1')
element.setAttribute('aria-disabled','true')})}
function l_enableFocusableElements(container){const focusableElements=l_getFocusableElements(container)
focusableElements.forEach((element)=>{element.removeAttribute('tabindex')
element.removeAttribute('aria-disabled')})}
function l_throttle(fn,delay){let lastCall=0
return function(...args){const now=new Date().getTime()
if(now-lastCall<delay){return}
lastCall=now
return fn(...args)}}
function l_addEventDelegate({context=document.documentElement,event='click',selector,handler,capture=!1,}){const listener=function(e){for(let target=e.target;target&&target!==this;target=target.parentNode){if(target.matches(selector)){handler.call(target,e,target)
break}}}
context.addEventListener(event,listener,capture)
return()=>{context.removeEventListener(event,listener,capture)}}
function l_debounce(fn,wait){let t
return(...args)=>{clearTimeout(t)
t=setTimeout(()=>fn.apply(this,args),wait)}}
function l_fetchConfig(type='json'){return{method:'POST',headers:{'Content-Type':'application/json',Accept:`application/${type}`},}}
function l_getSectionDOM(html,selector='.shopify-section'){return new DOMParser().parseFromString(html,'text/html').querySelector(selector)}
function l_updateHeaderCSSVariables(){var headerSection=headerSection||document.querySelector('.section-header')
var announcementBarSection=announcementBarSection||document.querySelector('.section-announcement-bar')
document.documentElement.style.setProperty('--l-viewport-height',`${visualViewport?.height ?? window.innerHeight}px`)
document.documentElement.style.setProperty('--l-header-height',`${headerSection?.scrollHeight || 0}px`)
document.documentElement.style.setProperty('--l-announcement-bar-height',`${announcementBarSection?.scrollHeight || 0}px`)}
const l_trapFocusHandlers={}
function l_trapFocus(container,defaultElementToFocus){const elements=l_getFocusableElements(container)
const first=elements[0]
const last=elements[elements.length-1]
const elementToFocus=defaultElementToFocus||first
l_removeTrapFocus()
l_trapFocusHandlers.focusin=(event)=>{if(event.target!==container&&event.target!==last&&event.target!==first)return
document.addEventListener('keydown',l_trapFocusHandlers.keydown)}
l_trapFocusHandlers.focusout=function(){document.removeEventListener('keydown',l_trapFocusHandlers.keydown)}
l_trapFocusHandlers.keydown=function(event){if(event.code.toUpperCase()!=='TAB')return
if(event.target===last&&!event.shiftKey){event.preventDefault()
first.focus()}
if((event.target===container||event.target===first)&&event.shiftKey){event.preventDefault()
last.focus()}}
document.addEventListener('focusout',l_trapFocusHandlers.focusout)
document.addEventListener('focusin',l_trapFocusHandlers.focusin)
elementToFocus.focus()
if(elementToFocus.tagName==='INPUT'&&['search','text','email','url'].includes(elementToFocus.type)&&elementToFocus.value){elementToFocus.setSelectionRange(0,elementToFocus.value.length)}}
function l_removeTrapFocus(elementToFocus=null){document.removeEventListener('focusin',l_trapFocusHandlers.focusin)
document.removeEventListener('focusout',l_trapFocusHandlers.focusout)
document.removeEventListener('keydown',l_trapFocusHandlers.keydown)
if(elementToFocus)elementToFocus.focus()}
function l_pauseAllMedia(){document.querySelectorAll('.js-youtube').forEach((video)=>{video.contentWindow.postMessage('{"event":"command","func":"'+'pauseVideo'+'","args":""}','*')})
document.querySelectorAll('.js-vimeo').forEach((video)=>{video.contentWindow.postMessage('{"method":"pause"}','*')})
document.querySelectorAll('video').forEach((video)=>video.pause())
document.querySelectorAll('product-model').forEach((model)=>{if(model.modelViewerUI)model.modelViewerUI.pause()})
document.querySelectorAll('l-media-video').forEach((video)=>{video.player.pause()})}
function l_formatMoney(cents,format=''){let value=''
const placeholderRegex=/\{\{\s*(\w+)\s*\}\}/
const formatString=format||theme.money_format||'${{amount}}'
if(typeof cents=='string'){cents=cents.replace('.','')}
function defaultOption(opt,def){return typeof opt=='undefined'?def:opt}
function formatWithDelimiters(number,precision,thousands,decimal){precision=defaultOption(precision,2)
thousands=defaultOption(thousands,',')
decimal=defaultOption(decimal,'.')
if(isNaN(number)||number==null){return 0}
number=(number/100.0).toFixed(precision)
var parts=number.split('.'),dollars=parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,'$1'+thousands),cents=parts[1]?decimal+parts[1]:''
return dollars+cents}
switch(formatString.match(placeholderRegex)[1]){case 'amount':value=formatWithDelimiters(cents,2)
break
case 'amount_no_decimals':value=formatWithDelimiters(cents,0,' ','.')
break
case 'amount_with_comma_separator':value=formatWithDelimiters(cents,2,'.','.')
break
case 'amount_no_decimals_with_comma_separator':value=formatWithDelimiters(cents,0,'.','.')
break}
return formatString.replace(placeholderRegex,value)}
function l_lockBodyScroll(elementName){document.documentElement.classList.add('js-block-page')
if(elementName){document.documentElement.classList.add(`js-block-page-${elementName}`)}}
function l_unLockBodyScroll(elementName){if(elementName){document.documentElement.classList.remove(`js-block-page-${elementName}`)
const isExistAnotherBlockedClass=Array.from(document.documentElement.classList).some((cls)=>cls.startsWith('js-block-page-'))
!isExistAnotherBlockedClass&&document.documentElement.classList.remove('js-block-page')}else{document.documentElement.classList.remove('js-block-page')}}
function l_setupVariablesBeforeOpenModal(){const announcementBarSection=document.getElementById('announcementBar')
const headerSection=document.getElementById('header')
document.documentElement.style.setProperty('--l-viewport-height',`${visualViewport?.height ?? window.innerHeight}px`)
document.documentElement.style.setProperty('--l-header-height',`${headerSection?.offsetHeight || 0}px`)
document.documentElement.style.setProperty('--l-announcement-bar-height',`${announcementBarSection?.offsetHeight || 0}px`)}
function l_isElementInViewport(el){const rect=el.getBoundingClientRect()
return(rect.top>=0&&rect.left>=0&&rect.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&rect.right<=(window.innerWidth||document.documentElement.clientWidth))}
const L_ATC={cartDrawer:null,handleConfigWithFormEl(formEl){const config=l_fetchConfig('javascript')
config.headers['X-Requested-With']='XMLHttpRequest'
delete config.headers['Content-Type']
const formData=new FormData(formEl)
config.body=formData
return config},handleConfigWithVariantId(addingData){const config=l_fetchConfig('javascript')
config.headers['X-Requested-With']='XMLHttpRequest'
delete config.headers['Content-Type']
const formData=new FormData()
addingData.forEach((item,index0)=>{formData.append(`items[${index0}][quantity]`,item.quantity)
formData.append(`items[${index0}][id]`,item.id)})
config.body=formData
return config},addToCart(config,id='234na08fa3'){return fetch(window.theme.routes.cart_add_url,config).then((response)=>response.json()).then((response)=>{if(response.status){document.dispatchEvent(new CustomEvent('l:cart:error',{detail:{id,description:response.description}}))
return}
if(!this.cartDrawer)this.cartDrawer=document.getElementById('CartDrawer')
if(!this.cartDrawer){return}
document.dispatchEvent(new CustomEvent('l:cart:updated',{bubbles:!0,detail:{id,response}}))}).catch((error)=>{console.error(error)})},}
class LTACollapsibleTab extends HTMLElement{constructor(){super()}
connectedCallback(){this.trigger=this.querySelector('[data-trigger]')
this.content=this.querySelector('[data-content]')
this.expandedClass='is-expanded'
this.collapsedClass='is-collapsed'
this.collapsedHeight='0px'
this.oneAtATime=!0
this.isScrollIntoView=this.dataset.scrollIntoView==='true'
this.transitionendEvent=this.transitionendEventName()
this.dataset.oneOpen==='false'&&(this.oneAtATime=!1)
if(this.getAttribute('open')==='true'){this.selected=!0
this.classList.add(this.expandedClass)
this.setExpandedAria()}else{this.content.style.height=this.collapsedHeight
this.classList.add(this.collapsedClass)
this.setCollapsedAria()
l_disableFocusableElements(this.content)}
this.content.removeAttribute('hidden')
this.trigger.addEventListener('click',(e)=>this.toggle(e))}
toggle(e){e.preventDefault()
this.selected?this.close():this.open()
if(this.selected&&this.oneAtATime){const tabsContainer=this.closest('[data-collapsible-wrapper]')
const collapsibleTabs=tabsContainer?.querySelectorAll('l-collapsible-tab')
collapsibleTabs?.length&&collapsibleTabs.forEach((tab)=>{tab!==this&&tab.selected&&tabsContainer!==tab&&tab.close()})}}
open(){this.selected=!0
this.expand()
this.setAttribute('open',!0)
l_enableFocusableElements(this.content)}
close(){this.selected=!1
this.collapse()
this.removeAttribute('open')
l_disableFocusableElements(this.content)}
expand(){const onTransitionEnd=((event)=>{if(event.target===this.content){this.content.removeEventListener(this.transitionendEvent,onTransitionEnd)
this.isOpen&&requestAnimationFrame(()=>{this.content.style.transition='0'
this.content.style.height='auto'
requestAnimationFrame(()=>{this.content.style.height=null
this.content.style.transition=null
this.setExpandedAria()})})}}).bind(this)
this.content.addEventListener(this.transitionendEvent,onTransitionEnd)
this.isOpen=!0
this.classList.add(this.expandedClass)
this.classList.remove(this.collapsedClass)
this.content.style.height=this.content.scrollHeight+'px'}
collapse(){const onTransitionEnd=((event)=>{if(event.target===this.content){this.content.removeEventListener(this.transitionendEvent,onTransitionEnd)
if(!this.isOpen){this.setCollapsedAria()
this.classList.add(this.collapsedClass)}}}).bind(this)
this.content.addEventListener(this.transitionendEvent,onTransitionEnd)
this.isOpen=!1
this.classList.remove(this.expandedClass)
requestAnimationFrame(()=>{this.content.style.transition='0'
this.content.style.height=this.content.scrollHeight+'px'
requestAnimationFrame(()=>{this.content.style.transition=null
this.content.style.height=this.collapsedHeight})})
if(this.isScrollIntoView){l_debounce(()=>{this.scrollIntoView({behavior:'smooth',block:'center'})},400)()}}
destroy(){this.trigger&&this.trigger.removeEventListener('click',(e)=>this.toggle(e))
this.content&&this.content.removeAttribute('aria-hidden')
this.content&&(this.content.style.height='auto')
this.classList.remove(this.expandedClass,this.collapsedClass)
this.removeAttribute('open')}
transitionendEventName(){let eventName,testElement=document.createElement('div'),eventNames={transition:'transitionend',OTransition:'otransitionend',MozTransition:'transitionend',WebkitTransition:'webkitTransitionEnd',}
for(eventName in eventNames){if(eventNames.hasOwnProperty(eventName)&&testElement.style[eventName]!==!1){return eventNames[eventName]}}}
setExpandedAria(){this.trigger.setAttribute('aria-expanded','true')
this.content.removeAttribute('aria-hidden')
this.content.removeAttribute('tabindex')}
setCollapsedAria(){this.trigger.setAttribute('aria-expanded','false')
this.content.setAttribute('aria-hidden','true')
this.content.setAttribute('tabindex','-1')}}
customElements.define('l-collapsible-tab',LTACollapsibleTab)
class LTADrawer extends HTMLElement{constructor(){super()}
connectedCallback(){this.setupDrawer()}
setupDrawer(){this.triggerEls=document.querySelectorAll(this.dataset.triggerSelector)
this.closeBtnEls=this.querySelectorAll('[data-close]')
this.drawerInnerEl=this.querySelector('[data-drawer-inner]')
this.triggerEl=null
this.modalName=this.dataset.modalName||'drawer'
this.triggerEls.forEach((triggerEl)=>{triggerEl.addEventListener('click',()=>{this.drawer_open(triggerEl)})})
this.closeBtnEls.forEach((closeBtnEl)=>{closeBtnEl.addEventListener('click',()=>{this.drawer_close()})})}
drawer_open(triggerEl){l_setupVariablesBeforeOpenModal()
l_lockBodyScroll(this.modalName)
this.classList.remove('l-hidden')
requestAnimationFrame(()=>{this.classList.add('is-active')})
if(triggerEl){this.triggerEl=triggerEl
l_trapFocus(this.drawerInnerEl)}
window.addEventListener('click',this.drawer_closeOutsideOnClick.bind(this))
window.addEventListener('keyup',this.drawer_closeOutsideOnEscape.bind(this))}
drawer_close(){l_unLockBodyScroll(this.modalName)
this.classList.remove('is-active')
window.l_debounce(()=>{this.classList.add('l-hidden')},400)()
if(this.triggerEl){l_removeTrapFocus(this.triggerEl)
this.triggerEl=null}
window.removeEventListener('click',this.drawer_closeOutsideOnClick)
window.removeEventListener('keyup',this.drawer_closeOutsideOnEscape)}
drawer_closeOutsideOnClick(event){const target=event.target
const isOutsideClick=!this.drawerInnerEl.contains(target)&&!Array.from(this.triggerEls).some((el)=>el.contains(target))
if(isOutsideClick)this.drawer_close()}
drawer_closeOutsideOnEscape(event){if(event.code.toUpperCase()==='ESCAPE'){this.drawer_close()}}}
customElements.define('l-drawer',LTADrawer)
class LTAHeader extends HTMLElement{constructor(){super()}
connectedCallback(){this.cartLinkEls=this.querySelectorAll('[data-cart-link]')
this.handleCartLinkClick()
this.scrollEvent()
document.addEventListener('rebuy:cart.change',(event)=>{const cart=event.detail.cart.cart
this.cartLinkEls.forEach((cartLinkEl)=>{const cartCountEl=cartLinkEl.querySelector('[data-cart-count]')
if(!cartCountEl)return
const n=cart.item_count
const wasActive=cartCountEl.classList.contains('is-active')
cartCountEl.classList.toggle('is-active',n>0)
cartCountEl.hidden=n===0
cartCountEl.textContent=n>9?'9+':n>0?String(n):''
if(!wasActive&&n>0){cartCountEl.classList.remove('is-entering');void cartCountEl.offsetWidth;cartCountEl.classList.add('is-entering')}
cartLinkEl.setAttribute('aria-label',n?`Cart, ${n} item${n>1?'s':''}`:'Cart, empty')})})}
handleCartLinkClick(event){this.cartLinkEls.forEach((cartLinkEl)=>{cartLinkEl.addEventListener('click',(event)=>{event.preventDefault()
window.Rebuy?.SmartCart?.show?.()})})}
scrollEvent(){const headerHeight=this.offsetHeight
document.addEventListener('scroll',l_debounce(()=>{console.log({scrollY:window.scrollY,headerHeight})
this.parentElement.classList.toggle('is-active',window.scrollY>=headerHeight)},50))}}
customElements.define('l-header',LTAHeader)
class LTAHeaderMobile extends HTMLElement{constructor(){super()}
connectedCallback(){this.toggleMenuBtnEl=document.getElementById('mobileToggleHamburger')
this.drawerInnerEl=this.querySelector('[data-inner]')
this.closeBtnEls=this.querySelectorAll('[data-header-close]')
this.modalName='header'
if(this.toggleMenuBtnEl)this.setupEvents()}
setupEvents(){this.toggleMenuBtnEl.addEventListener('click',()=>{const isOpen=this.classList.contains('is-active')
isOpen?this.close():this.open()})
this.closeBtnEls.forEach((closeBtnEl)=>{closeBtnEl.addEventListener('click',()=>{this.close()})})}
open(){this.toggleMenuBtnEl.classList.add('is-active')
l_setupVariablesBeforeOpenModal()
l_lockBodyScroll(this.modalName)
this.classList.remove('l-hidden')
requestAnimationFrame(()=>{this.classList.add('is-active')})
document.addEventListener('click',this.handleOnClickOutSide.bind(this))}
close(){this.toggleMenuBtnEl.classList.remove('is-active')
l_unLockBodyScroll(this.modalName)
this.classList.remove('is-active')
l_debounce(()=>{this.classList.add('l-hidden')},400)()
document.removeEventListener('click',this.handleOnClickOutSide.bind(this))}
handleOnClickOutSide(event){if(!this.drawerInnerEl.contains(event.target)&&!this.toggleMenuBtnEl.contains(event.target)){this.close()}}}
customElements.define('l-header-drawer-mobile',LTAHeaderMobile)
class LTAHeaderDesktop extends HTMLElement{constructor(){super()}
connectedCallback(){this.level1ListLinkEl=document.getElementById('headerLv1Links')
if(!this.level1ListLinkEl)return
this.menuDrawerEls=this.querySelectorAll('[id^="headerMenuDrawerLv2-"], [id^="headerMenuDrawerLv3-"]')
this.level1LinkEls=this.level1ListLinkEl.querySelectorAll('[data-lv1-link]')
this.level2LinkEls=this.querySelectorAll('[data-lv2-link]')
this.singleLinkEls=this.querySelectorAll('[data-single-link]')
this.modalName='headerDesktop'
l_debounce(()=>{this.setupLv1MouseOverEvents()
this.handleOnClickOutSide()},1000)()}
setupLv1MouseOverEvents(){this.level1LinkEls.forEach((level1LinkEl)=>{level1LinkEl.addEventListener('mouseenter',()=>{const menuHandle=level1LinkEl.dataset.lv1Link
l_setupVariablesBeforeOpenModal()
l_lockBodyScroll(this.modalName)
this.level1LinkEls.forEach((level1LinkEl)=>{level1LinkEl.classList.toggle('is-active',level1LinkEl.dataset.lv1Link===menuHandle)})
this.menuDrawerEls.forEach((menuDrawerEl)=>{menuDrawerEl.classList.toggle('is-active',menuDrawerEl.id===`headerMenuDrawerLv2-${menuHandle}`)})
this.classList.add('is-active')})})
this.level2LinkEls.forEach((level2LinkEl)=>{level2LinkEl.addEventListener('mouseenter',()=>{const menuHandle=level2LinkEl.dataset.lv2Link
this.menuDrawerEls.forEach((menuDrawerEl)=>{if(menuDrawerEl.id.startsWith('headerMenuDrawerLv3-')){menuDrawerEl.classList.toggle('is-active',menuDrawerEl.id===`headerMenuDrawerLv3-${menuHandle}`)}})})})
this.singleLinkEls.forEach((singleLinkEl)=>{singleLinkEl.addEventListener('mouseenter',()=>{this.menuDrawerEls.forEach((el)=>{if(el.id.startsWith('headerMenuDrawerLv3-')){el.classList.remove('is-active')}})})})}
handleOnMouseOut(){this.level1ListLinkEl.addEventListener('mouseleave',()=>{this.level1LinkEls.forEach((el)=>el.classList.remove('is-active'))
this.menuDrawerEls.forEach((el)=>el.classList.remove('is-active'))})}
handleOnClickOutSide(){document.addEventListener('click',(event)=>{const isClickOutside=![this.level1ListLinkEl,...this.menuDrawerEls].some((el)=>el.contains(event.target))
if(isClickOutside){this.classList.remove('is-active')
this.level1LinkEls.forEach((el)=>el.classList.remove('is-active'))
this.menuDrawerEls.forEach((el)=>el.classList.remove('is-active'))
l_unLockBodyScroll(this.modalName)}})}}
customElements.define('l-header-drawer-desktop',LTAHeaderDesktop)
class LTACartCount extends HTMLElement{constructor(){super()}
connectedCallback(){this.countLabelEl=this.querySelector('[data-count-label]')||this
document.addEventListener('rebuy:cart.change',(event)=>{const cart=event.detail.cart.cart
console.log(cart)
this.countLabelEl.innerHTML=cart.item_count})}}
customElements.define('l-cart-count',LTACartCount)
document.addEventListener('keydown',(event)=>{if(event.code.toUpperCase()!=='ESCAPE')return
const openMenuItem=document.activeElement&&document.activeElement.closest('.l-header__menu-item--lv1')
if(openMenuItem)document.activeElement.blur()})